<template>
	<div class="item item-radio-wrapper">
		<div class="radio-item">
			<span class="label"
				>{{ field.dynamicFieldName }}<span class="required ml6" v-if="field.config == 1">*</span></span
			>
			<div class="item-content" @click="openPicker">
				<span class="item-value" v-if="selectedLabel">{{ selectedLabel }}</span>
				<span class="item-value item-placeholder" v-else>{{ field.dynamicFieldDescribed || '请选择' }}</span>
				<span class="icon-font iconjiantouyou"></span>
			</div>
		</div>

		<m-popup-bottom-list
			v-if="visible"
			:visible.sync="visible"
			:title="field.dynamicFieldName || '请选择'"
			:mutliMode="false"
			:defaultValue="defaultValue"
			:list="optionList"
			get-container="body"
			wrap-class-name="ir-appointment-radio-wrap"
			@handleOk="handleConfirm"
		></m-popup-bottom-list>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import mPopupBottomList from '@/components/m-popup-bottom-list.vue';

const props = defineProps({
	field: {
		type: Object,
		required: true
	},
	index: {
		type: Number,
		required: true
	}
});

const emit = defineEmits(['update']);

const visible = ref(false);

const internalSelectedValue = ref('');

watch(
	() => props.field.dynamicFieldValue,
	newVal => {
		internalSelectedValue.value = newVal || '';
	},
	{ immediate: true }
);

const optionList = computed(() => {
	if (!props.field.conditionOptionVOList) return [];
	return props.field.conditionOptionVOList.map((opt, idx) => ({
		id: idx,
		label: opt.optionName,
		checked: false
	}));
});

const defaultValue = computed(() => {
	return internalSelectedValue.value ? parseInt(internalSelectedValue.value) : '';
});

const selectedLabel = computed(() => {
	if (!internalSelectedValue.value) return '';
	const options = props.field.conditionOptionVOList || [];
	const selectedIndex = parseInt(internalSelectedValue.value);
	return options[selectedIndex]?.optionName || '';
});

const openPicker = () => {
	visible.value = true;
};

const updateParent = () => {
	emit('update', internalSelectedValue.value);
};

const handleConfirm = selectedId => {
	internalSelectedValue.value = selectedId.toString();
	updateParent();
	visible.value = false;
};
</script>

<style lang="less" scoped>
.radio-item {
	width: 100%;
	display: flex;
	align-items: center;
	justify-items: center;
	font-size: 0.15rem;
	color: #333;

	.label {
		flex-shrink: 0;
		width: 0.83rem;
	}

	.item-content {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		line-height: 0.21rem;

		.icon-font {
			margin-left: 0.06rem;
		}
	}

	.item-value {
		max-width: 76%;
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 400;
		text-align: right;
		word-break: break-all;
	}

	.item-placeholder {
		color: #dcdcdc;
	}

	.ml6 {
		margin-left: 0.06rem;
	}

	.required {
		color: #eb5149;
		font-size: 0.15rem;
		font-weight: 400;
		vertical-align: middle;
	}
}
</style>
<style lang="less">
.ir-appointment-radio-wrap {
	.btn:active,
	.btn.active {
		background-color: #3f5bd6;
	}
}
</style>
